









import {Component, Vue, Prop} from "vue-property-decorator";
import AttributeSet from "@/api/AttributeSet";
import CompareService from "@/service/CompareService";
import RenderModal from "@/components/Shared/RenderModal.vue";
import Brand from "@/api/Brand";
import CompareModalHeader from "@/components/Compare/CompareModal/CompareModalHeader.vue";
import CompareModalBody from "@/components/Compare/CompareModal/CompareModalBody.vue";
import CompareSearch from "@/api/Compare/CompareSearch";
import Product from "@/api/Product";

@Component({
  components: {CompareModalBody, CompareModalHeader, RenderModal}
})
export default class CompareModal extends Vue {
  @Prop() private attributeSet!: AttributeSet;
  @Prop({default: true}) private isMobile!: boolean;
  @Prop({default: []}) private currentProductIds!: number[];
  private brands: Brand[] | null = null;
  private compareSearch: CompareSearch | null = null;
  private products: Product[] | null = null;

  get showCompareModal() {
    return this.$store.getters['compare/getShowCompareProductSelectModal'];
  }

  closeCompareModal() {
    this.$store.dispatch('compare/hideCompareProductSelectModal');
  }

  async getBrands() {
    if (this.attributeSet.attributeSetId) {
      this.brands = await CompareService.getBrandsBySetId(this.attributeSet.attributeSetId);
    }
  }

  async mounted() {
    await this.getBrands();
  }

  compareSearchChanged(compareSearch: CompareSearch) {
    this.compareSearch = compareSearch;
    this.getProducts();
  }

  async getProducts() {
    if (this.compareSearch) {
      this.products = await CompareService.getProductsByBrandsAndSetId(this.compareSearch);
    }
  }

  selectProduct(productId: number) {
    this.$emit("product-selected", productId);
    this.closeCompareModal();
  }
}
